/* eslint-disable */

import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDModal from "components/MDModal";

import { MdOutlineKeyboardArrowRight } from "react-icons/md";

import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

import prototype from "assets/images/new-device.jpg";

const style = {
  display: "grid",
  gridTemplateColumns: "1fr",
  justifyItems: "center",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "50%",
  bgcolor: "background.paper",
  border: "1px solid #B69552",
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  const [serialNumber, setSerialNumber] = useState("");
  const addDevice = () => {
    props.handleClose();
    props.setAddDevice(false);
    props.setDevice(true);
  };

  const handleSubmit = async () => {
    const sub = JSON.parse(localStorage.getItem("user")).sub;
    if (serialNumber === "" || sub === undefined) {
      return;
    }
    try {
      const response = await fetch(
        "https://int.api.chefaicookware.com/device-service/device/link",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ serialNumber, sub }),
        }
      );

      if (!response.ok) {
        let errorMessage = `Device with serial number ${serialNumber} not found!`;
        alert(errorMessage);
        throw new Error(errorMessage);
      }
      addDevice();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return props.showCircle ? (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-device-add"
        aria-describedby="modal-device-add-description"
      >
        <Box sx={style}>
          {/* <CircularProgress size={window.innerHeight / 8} thickness={4} /> */}
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Serial Number
          </Typography>
          <TextField
            type="text"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            value={serialNumber}
            onChange={(e) => setSerialNumber(e.target.value)}
          />
          <MDButton variant="gradient" color="dark" onClick={handleSubmit}>
            Register Device
            <MdOutlineKeyboardArrowRight />
          </MDButton>
        </Box>
      </Modal>
    </div>
  ) : (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-device-add"
        aria-describedby="modal-device-add-description"
      >
        <Box sx={style}>
          <Card>
            <MDBox pb={2} px={3}>
              <DefaultProjectCard
                image={prototype}
                label="Serial No. 986830"
                title="FRY-AI Model 1"
                icon={
                  <>
                    <Icon color="info">bluetooth_connected</Icon>{" "}
                    <Icon color="goldComplement">wifi</Icon> <Icon color="success">check</Icon>
                  </>
                }
                action={{}}
              />
            </MDBox>
          </Card>
          <MDButton variant="gradient" color="dark" onClick={addDevice}>
            add device
          </MDButton>
        </Box>
      </Modal>
    </div>
  );
}
